(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer_bot"] && !Shopify.designMode) return;
  try {
    
(function () {
  var btn = document.getElementById('ft-scroll-top-{{ section.id }}');
  if (!btn) return;
  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new_best_seller"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.getElementById('bs-{{ section.id }}');
  if (!section) return;

  section.querySelectorAll('.bs__atc[data-variant]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.dataset.variant;
      var label = btn.dataset.label || 'Add to cart';
      if (!id) return;

      btn.textContent = 'Adding…';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = '✓ Added!';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(function () {
          btn.textContent = '+ ' + label;
          btn.disabled = false;
        }, 2000);
      })
      .catch(function () {
        btn.textContent = 'Error – try again';
        btn.disabled = false;
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
